import * as THREE from "three";
import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils";
import { Vertex, Edge, Face, UniqueVertex } from "./Geo";
import { UVUnwrapper } from "xatlas-three";
import { BufferGeometry, Vector2 } from "three";
import { Chart, ChartLSCMSolve } from "./Chart";
import { face_uv_area_signed } from "./Utils";
import { AppSettings } from "../AppSettings";

export class UVMapper {
  initialized = false;
  arrayIndex:Array<number> = [];
  countVertices:number = 0;
  faceMap: Array<Face> = [];
  vertexMap: Array<Vertex> = [];
  uniqueVerticesMap: Array<UniqueVertex> = [];
  edgeMap: Array<Edge> = [];
  chartMaps: Array<Chart> = [];

  constructor(geometry:BufferGeometry|null, seams:boolean = true) {
    if(geometry !=null)
    {
      this.init(geometry, seams);
    }
  }
  init(geometry:BufferGeometry, seams:boolean) {
    if(geometry.index != null)this.arrayIndex = Array.prototype.slice.call(geometry.index.array);
    this.countVertices = geometry.getAttribute("position").array.length / 3;
    let positions = geometry.getAttribute("position").array;

    let normals = geometry.getAttribute("normal").array;
    let uv = geometry.getAttribute("uv").array;
    if(AppSettings.DEBUG)console.log(this.arrayIndex);
    this.faceMap = [];
    this.vertexMap = [];
    this.uniqueVerticesMap = [];
    this.edgeMap = [];

    for (let vertex = 0; vertex < this.countVertices; vertex++) {
      this.vertexMap.push(
        new Vertex(
          new THREE.Vector3(
            positions[vertex * 3],
            positions[vertex * 3 + 1],
            positions[vertex * 3 + 2]
          ),
          new THREE.Vector2(uv[vertex * 2], uv[vertex * 2 + 1]),
          new THREE.Vector3(
            normals[vertex * 3],
            normals[vertex * 3 + 1],
            normals[vertex * 3 + 2]
          ),
          vertex
        )
      );

      this.initUniqueVertices(this.vertexMap[vertex]);
    }

    if(geometry.index != null)
    {
      
      for (
        let faceIndex = 0;
        faceIndex < this.arrayIndex.length / 3;
        faceIndex++
      ) {
        let vertex1 = this.vertexMap[this.arrayIndex[faceIndex * 3]];
        let vertex2 = this.vertexMap[this.arrayIndex[faceIndex * 3 + 1]];
        let vertex3 = this.vertexMap[this.arrayIndex[faceIndex * 3 + 2]];
  
        vertex1.addFace(faceIndex);
        vertex2.addFace(faceIndex);
        vertex3.addFace(faceIndex);
  
        this.faceMap.push(new Face(vertex1, vertex2, vertex3, faceIndex));
      }
    }
    else
    {
      console.warn("Geometry index is null");
      for (
        let faceIndex = 0;
        faceIndex < this.countVertices / 3;
        faceIndex++
      ) {
        let vertex1 = this.vertexMap[3 * faceIndex];
        let vertex2 = this.vertexMap[3 * faceIndex + 1];
        let vertex3 = this.vertexMap[3 * faceIndex + 2];
  
        vertex1.addFace(faceIndex);
        vertex2.addFace(faceIndex);
        vertex3.addFace(faceIndex);
  
        this.faceMap.push(new Face(vertex1, vertex2, vertex3, faceIndex));
      }   
    }

    let edge = null;
    for (let faceIndex = 0; faceIndex < this.faceMap.length; faceIndex++) {
      for (let faceIndex2 = 0; faceIndex2 < this.faceMap.length; faceIndex2++) {
        edge = this.faceMap[faceIndex].getCommonEdgeIndex(
          this.faceMap[faceIndex2]
        );
        if (faceIndex != faceIndex2 && edge != null) {
          this.faceMap[faceIndex].setOppositeFaceIndex(
            edge.i,
            this.faceMap[faceIndex2].indexFace
          );
        }
      }
    }
    this.solveTriEdges();
    
    if(seams)this.checkEdgeSeams();
    
    
    for (let faceIndex = 0; faceIndex < this.faceMap.length; faceIndex++) {
      for (
        let edgeIndex = 0;
        edgeIndex < this.faceMap[faceIndex].edges.length;
        edgeIndex++
      ) {
        this.edgeMap.push(this.faceMap[faceIndex].edges[edgeIndex]);
        this.addEdgeToUniqueVertices(
          this.faceMap[faceIndex],
          this.faceMap[faceIndex].edges[edgeIndex]
        );
      }
    }

    if(AppSettings.DEBUG)console.log(this.faceMap);
    if(AppSettings.DEBUG)console.log(this.uniqueVerticesMap);
    this.initialized = true;
    for (let i = 0; i < this.uniqueVerticesMap.length; i++) {
      this.uniqueVerticesMap[i].computeEdges();
    }


    if(!seams)
    {
      for (let i = 0; i < this.uniqueVerticesMap.length; i++) {
        this.uniqueVerticesMap[i].sewUV();
      }
    }
  }
  
  sewAll()
  {
    for (let i = 0; i < this.uniqueVerticesMap.length; i++) {
      this.uniqueVerticesMap[i].sewAll();
      this.uniqueVerticesMap[i].sewUV();
    }
  }
  //#region Functions
  addEdgeToUniqueVertices(face:Face, edge:Edge) {

    for (let i = 0; i < this.uniqueVerticesMap.length; i++) {
      if (this.uniqueVerticesMap[i].equalsPosition(edge.vertex1)) {
        this.uniqueVerticesMap[i].addVertexEdge(edge.vertex1, edge, face);
      } else if (this.uniqueVerticesMap[i].equalsPosition(edge.vertex2)) {
        this.uniqueVerticesMap[i].addVertexEdge(edge.vertex2, edge, face);
      } 
    }
  }
  
  initUniqueVertices(vertex:Vertex) {

    if (this.uniqueVerticesMap.length == 0)
      this.uniqueVerticesMap.push(new UniqueVertex(0, vertex.position));
    else {
      let alreadyExists = false;
      for (let i = 0; i < this.uniqueVerticesMap.length; i++) {
        if (this.uniqueVerticesMap[i].equalsPosition(vertex)) {
          alreadyExists = true;
          break;
        }
      }

      if (!alreadyExists) {
        this.uniqueVerticesMap.push(
          new UniqueVertex(this.uniqueVerticesMap.length, vertex.position)
        );
      }
    }
  }


  checkEdgeSeams() {

    let edge = null;
    for (let faceIndex = 0; faceIndex < this.faceMap.length; faceIndex++) {
      for (let faceIndex2 = 0; faceIndex2 < this.faceMap.length; faceIndex2++) {
        edge = this.faceMap[faceIndex].getCommonEdgeIndex(
          this.faceMap[faceIndex2]
        );
        if (faceIndex != faceIndex2 && edge != null) {
          this.faceMap[faceIndex].setupEdgeSeams(
            edge.i,
            this.faceMap[faceIndex2].edges[edge.j]
          );
        }
      }
    }
  }

  updateUVGeometry(mesh:THREE.Mesh) {
    let newGeometry = new THREE.BufferGeometry();
    let vertices:Array<number> = [];
    let uv:Array<number> = [];
    let normal:Array<number> = [];

    for (let faceIndex = 0; faceIndex < this.faceMap.length; faceIndex++) {
      let verticesFace = this.faceMap[faceIndex].getVertices();
      for (let vertex = 0; vertex < 3; vertex++) {
        vertices = vertices.concat(verticesFace[vertex].getPositionPoints());
        uv = uv.concat(verticesFace[vertex].getUVPoints());
        normal = normal.concat(verticesFace[vertex].getNormalPoints());
      }
    }

    newGeometry.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(vertices, 3)
    );
    newGeometry.setAttribute("uv", new THREE.Float32BufferAttribute(uv, 2));
    newGeometry.setAttribute(
      "normal",
      new THREE.Float32BufferAttribute(normal, 3)
    );

    mesh.geometry = BufferGeometryUtils.mergeVertices(newGeometry);


  }


  chartingUVMap() {

    let faceArray = Array.from(Array(this.faceMap.length).keys());
    let chartFaces = [];
    let chartIndex = 0;
    this.chartMaps = [];

    if(AppSettings.DEBUG)console.log(`Total faces: ${this.faceMap.length}`);

    while (faceArray.length > 0) {
      chartFaces = [];

      chartFaces = this.exploreFaceChart(
        faceArray.splice(0, 1)[0],
        faceArray
      );

      this.chartMaps.push(new Chart(chartIndex));
      if(AppSettings.DEBUG)console.log(`Chart ${chartIndex}: ${chartFaces.length} faces`);

      while (chartFaces.length > 0) {
        this.chartMaps[chartIndex].addFace(this.faceMap[chartFaces.splice(0, 1)[0]]);
      }

      this.chartMaps[chartIndex].calculate();
      chartIndex++;
    }

    if(AppSettings.DEBUG)console.log(`Created ${this.chartMaps.length} charts`);

    // Debug: Log vertices per chart before solving
    if(AppSettings.DEBUG) {
      for (let i = 0; i < this.chartMaps.length; i++) {
        const chart = this.chartMaps[i];
        console.log(`Chart ${i}: ${chart.faces.length} faces, ${chart.vertices.length} unique vertices`);
      }
    }

    this.solveUVMap();

    
  }

  solveUVMap()
  {
    for(let i = 0; i< this.chartMaps.length;i++)
    {
      let chart = this.chartMaps[i];

      if(chart.chartLSCM?.context)
      {
        if(AppSettings.DEBUG)console.log(`Solving chart ${i}: pin1=${chart.pin1?.idChart}, pin2=${chart.pin2?.idChart}`);
        if(AppSettings.DEBUG)console.log(`Pin1 UV: (${chart.pin1?.uv.x}, ${chart.pin1?.uv.y}), Pin2 UV: (${chart.pin2?.uv.x}, ${chart.pin2?.uv.y})`);

        const result = ChartLSCMSolve(chart);
        if(AppSettings.DEBUG)console.log(`LSCM solve result: ${result}`);

        // Check for NaN after solving
        if(AppSettings.DEBUG) {
          let hasNaN = false;
          for (const v of chart.vertices) {
            if (isNaN(v.uv.x) || isNaN(v.uv.y)) {
              hasNaN = true;
              break;
            }
          }
          console.log(`Chart ${i} has NaN UVs after solve: ${hasNaN}`);
        }

        chart.applyUVToVertices();
        if(AppSettings.DEBUG)console.log(`Chart ${i} size after applyUVToVertices: (${chart.chartPack.size.x}, ${chart.chartPack.size.y})`);

        chart.rotateMinimumArea();
        if(AppSettings.DEBUG)console.log(`Chart ${i} size after rotateMinimumArea: (${chart.chartPack.size.x}, ${chart.chartPack.size.y})`);

        chart.chartLSCM = undefined;

      }
    }
    this.averageCharts();
    if(AppSettings.DEBUG) {
      console.log("After averageCharts:");
      for (let i = 0; i < this.chartMaps.length; i++) {
        console.log(`Chart ${i} size: (${this.chartMaps[i].chartPack.size.x}, ${this.chartMaps[i].chartPack.size.y})`);
      }
    }

    let maxSide = 0;
    let totSide = 0;
    for( let chart of this.chartMaps)
    {
      maxSide = Math.max(Math.max(chart.chartPack.size.x,chart.chartPack.size.y), maxSide);
      totSide+=Math.max(chart.chartPack.size.x,chart.chartPack.size.y);
    }
    for(let i = 0; i< this.chartMaps.length;i++)
    {
      let side = Math.max(this.chartMaps[i].chartPack.size.x,this.chartMaps[i].chartPack.size.y);

      this.chartMaps[i].uvScale(1 /  side  * (side/totSide) * 0.9 );
      let trans = new Vector2().subVectors(new Vector2(0.5,0.5),this.chartMaps[i].chartPack.origin);

      this.chartMaps[i].uvTranslate(trans);
    }
    

    this.packCharts();
    if(AppSettings.DEBUG)console.log(this.chartMaps);
  }

  exploreFaceChart(faceIndex:number, faceArray:Array<number>) {

    let neighbors = this.faceMap[faceIndex].getNeighborsIndex();

    let chartFaces = [faceIndex];
    for (let i = 0; i < neighbors.length; i++) {
      let neighbor = neighbors[i];

      if (neighbor != null  && faceArray.indexOf(neighbor) != -1) {
        faceArray.splice(faceArray.indexOf(neighbor), 1);
        chartFaces = chartFaces.concat(
          this.exploreFaceChart(neighbor, faceArray)
        );
      }
    }
    return chartFaces;
  }

  solveTriEdges() {
    for (let faceIndex = 0; faceIndex < this.faceMap.length; faceIndex++) {
      let diagFaces = []
      for (let faceIndex2 = 0; faceIndex2 < this.faceMap.length; faceIndex2++) {

        if (this.faceMap[faceIndex].commonEdgeDone) break;

        if (
          faceIndex != faceIndex2 &&
          this.faceMap[faceIndex].isCoplanar(this.faceMap[faceIndex2])
            && this.faceMap[faceIndex].getCommonEdgeIndex(this.faceMap[faceIndex2])
        ) {
          diagFaces.push(this.faceMap[faceIndex2]);
        }

      }

      if(diagFaces.length == 1)
      {
        this.faceMap[faceIndex].disableCommonEdgeTri(
          diagFaces[0]
        );
      }
    }
  }

  setEdgeSeam(vertexCount:number, booleanState:boolean) {
    this.edgeMap[vertexCount].edgeSeam = booleanState;
  }

  averageCharts()
  {

    let tot_uvarea = 0.0, tot_facearea = 0.0;
    let tot_fac, fac;
  
    if (this.chartMaps.length == 0) {
      return;
    }
  
    for (let i = 0 ; i < this.chartMaps.length ; i++) {
      let chart = this.chartMaps[i];
      

      chart.chartPack.origin.addVectors(chart.minV, chart.maxV).multiplyScalar(0.5);
      
      //Pas de scaleUV ou shear

      chart.chartPack.area = 0.0;    /* 3d area */
      chart.chartPack.rescale = 0.0; /* UV area, abusing rescale for tmp storage, oh well :/ */
      
      for( let face of chart.faces)
      {
        chart.chartPack.area += face.calculateArea();
        chart.chartPack.rescale += Math.abs(face_uv_area_signed(face));
      }
      tot_facearea += chart.chartPack.area;
      tot_uvarea += chart.chartPack.rescale;
    }
    
    if (tot_facearea == tot_uvarea || tot_facearea == 0.0 || tot_uvarea == 0.0) {
      return;
    }
    
    tot_fac = tot_facearea / tot_uvarea;
    
    if(AppSettings.DEBUG)console.log("tot_fac", tot_fac);
    for (let i = 0 ; i < this.chartMaps.length ; i++) {
      let chart = this.chartMaps[i];
      
      if (chart.chartPack.area != 0.0 && chart.chartPack.rescale != 0.0) {
        fac = chart.chartPack.area / chart.chartPack.rescale;

        /* Average scale*/
        chart.uvScale(fac / tot_fac);
        /* Get the current island center. */
        chart.calculateCurrentCenter();
        /* Move to original center. */
        let trans = chart.uvCentroid.clone().negate().add(chart.chartPack.origin);
        chart.uvTranslate(trans);
      }
    }

  }
  
  packCharts()
  {
    if (this.chartMaps.length === 0) return;

    if(AppSettings.DEBUG)console.log(`Packing ${this.chartMaps.length} charts`);

    const padding = 0.02; // 2% gap between islands
    const margin = 0.02;  // 2% margin from edges

    // Sort charts by height (tallest first) for shelf packing
    this.chartMaps.sort((a, b) => {
      return b.chartPack.size.y - a.chartPack.size.y;
    });

    // First pass: place charts at origin to measure total bounds
    // Shelf-based packing: place charts in rows, starting new row when needed
    let currentX = 0;
    let currentY = 0;
    let shelfHeight = 0;
    let maxX = 0;

    for (let chartIdx = 0; chartIdx < this.chartMaps.length; chartIdx++) {
      const chart = this.chartMaps[chartIdx];
      const chartW = chart.chartPack.size.x;
      const chartH = chart.chartPack.size.y;

      // Check if chart fits in current row (use arbitrary width, we'll scale later)
      if (currentX > 0 && currentX + chartW + padding > 1) {
        // Start new row
        currentX = 0;
        currentY += shelfHeight + padding;
        shelfHeight = 0;
      }

      // Update shelf height
      if (chartH > shelfHeight) {
        shelfHeight = chartH;
      }

      // Place chart at current position (bottom-left corner)
      const targetCenterX = currentX + chartW / 2;
      const targetCenterY = currentY + chartH / 2;

      const trans = new Vector2(
        targetCenterX - chart.chartPack.origin.x,
        targetCenterY - chart.chartPack.origin.y
      );
      chart.uvTranslate(trans);

      // Track max extent
      if (currentX + chartW > maxX) {
        maxX = currentX + chartW;
      }

      // Move to next position
      currentX += chartW + padding;
    }

    const totalHeight = currentY + shelfHeight;
    const totalWidth = maxX;

    // Calculate scale to fit within available space
    const availableSize = 1 - 2 * margin;
    const scaleX = availableSize / totalWidth;
    const scaleY = availableSize / totalHeight;
    const finalScale = Math.min(scaleX, scaleY);

    if(AppSettings.DEBUG)console.log(`Total bounds: ${totalWidth.toFixed(3)} x ${totalHeight.toFixed(3)}, scale: ${finalScale.toFixed(3)}`);

    // Apply final scale and offset to fit within margins
    for (const chart of this.chartMaps) {
      // Scale all UVs
      chart.uvScale(finalScale);
      // Translate to add margin
      chart.uvTranslate(new Vector2(margin, margin));
    }

    if(AppSettings.DEBUG)console.log("Packed charts:", this.chartMaps.length);
  }

  /**
   * Ensure all UV coordinates fit within [margin, 1-margin] bounds.
   * Scales up or down as needed to maximize UV space usage.
   */
  validateAndScaleBounds(margin: number)
  {
    if (this.chartMaps.length === 0) return;

    const EPSILON = 0.0001; // Minimum dimension threshold
    let minU = Infinity, minV = Infinity;
    let maxU = -Infinity, maxV = -Infinity;

    // Find actual bounds across all vertices
    for (const chart of this.chartMaps) {
      for (const v of chart.vertices) {
        minU = Math.min(minU, v.uv.x);
        minV = Math.min(minV, v.uv.y);
        maxU = Math.max(maxU, v.uv.x);
        maxV = Math.max(maxV, v.uv.y);
      }
    }

    let currentWidth = maxU - minU;
    let currentHeight = maxV - minV;
    const availableSize = 1 - 2 * margin;

    if(AppSettings.DEBUG)console.log(`UV bounds: [${minU.toFixed(4)}, ${minV.toFixed(4)}] to [${maxU.toFixed(4)}, ${maxV.toFixed(4)}]`);
    if(AppSettings.DEBUG)console.log(`Current size: ${currentWidth.toFixed(4)} x ${currentHeight.toFixed(4)}`);

    // Handle degenerate cases (collapsed to line or point)
    if (currentWidth < EPSILON && currentHeight < EPSILON) {
      // Collapsed to a point - place at center
      if(AppSettings.DEBUG)console.log("Degenerate UV: collapsed to point, placing at center");
      const offsetVec = new Vector2(0.5 - minU, 0.5 - minV);
      for (const chart of this.chartMaps) {
        chart.uvTranslate(offsetVec);
      }
      return;
    }

    // If collapsed to a line, use the non-zero dimension for scaling
    if (currentWidth < EPSILON) currentWidth = currentHeight;
    if (currentHeight < EPSILON) currentHeight = currentWidth;

    // Calculate scale to fit within bounds (can be > 1 to scale up)
    const scaleNeeded = Math.min(
      availableSize / currentWidth,
      availableSize / currentHeight
    ) * 0.95; // 95% to leave some breathing room

    if(AppSettings.DEBUG)console.log(`Scale needed: ${scaleNeeded.toFixed(3)}`);

    // Always apply scaling to maximize UV space usage
    const centerU = (minU + maxU) / 2;
    const centerV = (minV + maxV) / 2;

    for (const chart of this.chartMaps) {
      for (const v of chart.vertices) {
        v.uv.x = centerU + (v.uv.x - centerU) * scaleNeeded;
        v.uv.y = centerV + (v.uv.y - centerV) * scaleNeeded;
      }
      chart.calculateCurrentCenter();
    }

    // Recenter to fit within bounds (move to start at margin)
    const newMinU = centerU + (minU - centerU) * scaleNeeded;
    const newMinV = centerV + (minV - centerV) * scaleNeeded;
    const offsetU = margin - newMinU;
    const offsetV = margin - newMinV;

    const offsetVec = new Vector2(offsetU, offsetV);
    for (const chart of this.chartMaps) {
      chart.uvTranslate(offsetVec);
    }
  }

}

const unwrapper = new UVUnwrapper({ BufferAttribute: THREE.BufferAttribute });
// Default options
unwrapper.chartOptions = {
  fixWinding: true,
  maxBoundaryLength: 0,
  maxChartArea: 0,
  maxCost: 100,
  maxIterations: 2,
  normalDeviationWeight: 2,
  normalSeamWeight: 4,
  roundnessWeight: 0.009999999776482582,
  straightnessWeight: 6,
  textureSeamWeight: 1,
  useInputMeshUvs: false,
};
unwrapper.packOptions = {
  bilinear: true,
  blockAlign: false,
  bruteForce: false,
  createImage: false,
  maxChartSize: 0,
  padding: 2,
  resolution: 0,
  rotateCharts: true,
  rotateChartsToAxis: true,
  texelsPerUnit: 0,
};
